export { P165ArticleListPage as default } from './P165ArticleListPage';
